import React from 'react';
import { CompassIcon, LightbulbIcon, RulerIcon, LibraryIcon, ShieldCheckIcon, CalculatorIcon } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
const BENEFITS = [{
  icon: CompassIcon,
  title: 'Más claridad',
  text: 'Tenés un punto de partida para tu próximo proyecto.'
}, {
  icon: LightbulbIcon,
  title: 'Más ideas',
  text: 'Cada vez que termines algo, hay cientos de opciones para explorar.'
}, {
  icon: RulerIcon,
  title: 'Menos improvisación',
  text: 'Consultás referencias antes de empezar.'
}, {
  icon: LibraryIcon,
  title: 'Más organización',
  text: 'Todo queda reunido en una biblioteca.'
}, {
  icon: ShieldCheckIcon,
  title: 'Más confianza',
  text: 'Podés explorar proyectos diferentes con referencias disponibles.'
}, {
  icon: CalculatorIcon,
  title: 'Mejores presupuestos',
  text: 'Contás con recursos complementarios para organizar costos y precios.'
}];
export function BenefitsBlock() {
  return <div className="relative border-t border-[#EFEDE8]/10 bg-[#111111]" data-id="element-306" data-mp="7naarlipohs7">
      <div className="mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-307" data-mp="174wx4njljbsr">
        <h2 className="title-glow reveal mx-auto max-w-2xl text-center font-display text-2xl font-black uppercase leading-[1.1] tracking-tight text-[#F8F3EA] sm:text-4xl" data-id="element-308" data-mp="12cn24t3mjljm">
          Lo que cambia cuando tenés{' '}
          <span className="text-[#FF7A00]" data-id="element-309" data-mp="td9t21jewyzf">la Bóveda abierta</span>
        </h2>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-310" data-mp="1q2hgjf3ldi5z">
          {BENEFITS.map(benefit => <li key={benefit.title} className="reveal rounded-xl border border-[#EFEDE8]/10 bg-[#181512] p-6 transition-all duration-200 hover:-translate-y-1 hover:border-[#FF7A00]/40" data-id="element-311" data-mp="1l3werb8oyqff">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-[#D89A3D]/30 bg-[#111111]" data-id="element-312" data-mp="1c2ygzaoujf5a">
                <benefit.icon className="h-5 w-5 text-[#D89A3D]" aria-hidden="true" data-id="element-313" data-mp="5n5y0ikai7k1" />
              </span>
              <h3 className="mt-4 font-display text-sm font-extrabold uppercase tracking-tight text-[#F8F3EA]" data-id="element-314" data-mp="mroew31ipjw">
                {benefit.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-[#EFEDE8]/65" data-id="element-315" data-mp="741irxryvar7">
                {benefit.text}
              </p>
            </li>)}
        </ul>

        <div className="reveal mt-12 flex flex-col items-center" data-id="element-316" data-mp="3p94tby0pcez0">
          <CTAButton href="#oferta" size="large" data-id="element-317" data-mp="3tai14dncus8k">
            Quiero ver la oferta completa
          </CTAButton>
          <p className="mt-3 text-xs text-[#EFEDE8]/50" data-id="element-318" data-mp="3fitp0ad3w3rl">
            Pago único · Acceso digital · Garantía 7 días
          </p>
        </div>
      </div>
    </div>;
}